import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import * as isNil from 'lodash/isNil';

import { Formatter } from './formatter.interface';

export class CombinedStringFormatter implements Formatter {
	constructor(
		private stringFormat: string,
		public readonly defaultValue: string,
		/**
		 * isEveryDataRequiredToExist: If this flag is true, that means we show default value directly if any data point is missing
		 * if it's false, then we return template string, any slots that has doesn't have data will be replaced with default value.
		 */
		private isEveryDataRequiredToExist: boolean = true,
		private formatters: Formatter[] = []
	) { }
	public format(values: any, contentSvc?: ContentService): string {
		const isEveryDataNil = values && values.every(value => isNil(value));
		const isSomeDataNil = values && values.some(value => isNil(value));

		let updatedDefaultValue = this.defaultValue;

		// update default value if it is changed via DCR 
		if (!isNil(contentSvc) && this.defaultValue) {
			// builds DCR to override the default value if needed (eg Custom Net => CUSTOM_NET_FORMATTER_DCR)
			const dcrKey = new DcrKeyPipe().transform(this.defaultValue + '_FORMATTER_DCR');
			updatedDefaultValue = contentSvc.get(dcrKey, this.defaultValue);
		}

		if (isNil(values) || isEveryDataNil || (this.isEveryDataRequiredToExist && isSomeDataNil)) {
			return updatedDefaultValue;
		}

		let tempFormat = this.stringFormat;
		values.forEach(val => {
			this.formatters.forEach(formatter => {
				val = formatter.format(val, contentSvc);
			});

			tempFormat = tempFormat.replace('{0}', val || updatedDefaultValue);
		});
		return tempFormat;
	}
}
